import { noop } from 'es-toolkit';

export const useThumbnailManualReady = (
  enabled?: boolean
): [() => void, () => void] => {
  if (
    !enabled ||
    !window.thumbnailManualReadyEnable ||
    !window.thumbnailManualReadyResolve
  ) {
    return [noop, noop];
  }

  return [
    window.thumbnailManualReadyEnable,
    window.thumbnailManualReadyResolve
  ];
};
